import { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import ConversationList from "./ConversationList";
import ConversationThread from "./ConversationThread";

// Below md the page fills the screen under the navbar: layout padding + 75px navbar + layout
// padding (12px each side on xs, 16px on sm). dvh tracks the mobile browser's collapsing URL
// bar; plain vh is the fallback for browsers without it. md+ keeps the original desktop sizing.
const PANE_HEIGHT = {
  xs: "calc(100vh - 99px)",
  sm: "calc(100vh - 107px)",
  md: "calc(100vh - 140px)",
};
const PANE_HEIGHT_DVH = {
  xs: "calc(100dvh - 99px)",
  sm: "calc(100dvh - 107px)",
  md: "calc(100vh - 140px)",
};

function CustomerChat() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedId, setSelectedId] = useState(searchParams.get("conversation"));
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isPhone = useMediaQuery(theme.breakpoints.down("md"));
  const urlConversation = searchParams.get("conversation");

  // Follow the URL when it changes under us — on phones that's the browser/Android back
  // gesture closing a thread opened below.
  useEffect(() => {
    setSelectedId(urlConversation);
  }, [urlConversation]);

  // Phones show one pane at a time, so opening a thread gets its own history entry and the
  // back gesture returns to the list instead of leaving the page. Desktop is unchanged.
  const handleSelect = (id) => {
    setSelectedId(id);
    if (isPhone && id !== urlConversation) {
      const next = new URLSearchParams(searchParams);
      next.set("conversation", id);
      setSearchParams(next, { state: { chatThread: true } });
    }
  };

  const handleBack = () => {
    if (location.state?.chatThread) {
      navigate(-1);
      return;
    }
    // Arrived straight on a thread (deep link) — there's no list entry to go back to.
    setSelectedId(null);
    const next = new URLSearchParams(searchParams);
    next.delete("conversation");
    setSearchParams(next, { replace: true });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={{ xs: 1.5, sm: 2, md: 3 }}
        pb={{ xs: 0, md: 3 }}
        sx={{
          height: PANE_HEIGHT,
          "@supports (height: 100dvh)": { height: PANE_HEIGHT_DVH },
          minHeight: { xs: 400, md: "auto" },
        }}
      >
        <Grid container spacing={{ xs: 0, md: 2 }} sx={{ height: "100%" }}>
          <Grid
            item
            xs={12}
            md={4}
            sx={{ height: "100%", display: { xs: selectedId ? "none" : "block", md: "block" } }}
          >
            <ConversationList selectedId={selectedId} onSelect={handleSelect} />
          </Grid>
          <Grid
            item
            xs={12}
            md={8}
            sx={{ height: "100%", display: { xs: selectedId ? "block" : "none", md: "block" } }}
          >
            <ConversationThread conversationId={selectedId} onBack={handleBack} />
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default CustomerChat;
